/*
  IC free gift — adds a free product to the basket once it reaches a spend threshold,
  and takes it out again if the basket drops below it.
  Config comes from window.icFreeGift (snippets/ic-free-gift.liquid).
  The price itself is made £0 by a Shopify automatic "Buy X get Y" discount.
*/
(function () {
  var cfg = window.icFreeGift;
  if (!cfg || !cfg.variantId || !cfg.threshold) return;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  var busy = false;
  var queued = false;
  var timer;
  var failedAt = null;

  function giftUpdates(qty) {
    var u = {};
    u[cfg.variantId] = qty;
    return u;
  }

  function isCartWrite(url) {
    return /\/cart\/(add|change|update|clear)(\.js)?/.test(String(url || ''));
  }

  function isGift(item) {
    return String(item.variant_id) === String(cfg.variantId);
  }

  function post(path, body) {
    return nativeFetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function refreshCartUI(cart) {
    var halo = window.halo;
    if (!halo) return;
    if (document.body.classList.contains('template-cart') && halo.updateCart) {
      halo.updateCart(cart);
    } else if (halo.updateSidebarCart) {
      halo.updateSidebarCart(cart);
    }
  }

  function analyse(cart) {
    var a = { giftQty: 0, giftTotal: 0, others: 0, otherDiscount: false };
    a.otherDiscount = (cart.cart_level_discount_applications || []).some(function (d) {
      return d.total_allocated_amount > 0;
    });
    cart.items.forEach(function (item) {
      if (isGift(item)) {
        a.giftQty += item.quantity;
        a.giftTotal += item.final_line_price;
      } else {
        a.others += 1;
        (item.line_level_discount_allocations || []).forEach(function (d) {
          if (d.amount > 0) a.otherDiscount = true;
        });
      }
    });
    // Spend after discounts, not counting the gift itself (in pence).
    a.spend = cart.total_price - a.giftTotal;
    return a;
  }

  function sync() {
    if (busy) { queued = true; return; }
    busy = true;

    nativeFetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var a = analyse(cart);
        // The gift discount doesn't combine, so skip it when another discount is already applied.
        var qualifies = a.others > 0 && a.spend >= cfg.threshold && !a.otherDiscount && a.spend !== failedAt;
        var want = qualifies ? 1 : 0;
        // Never leave the gift in the basket at full price.
        if (a.giftQty && a.giftTotal > 0) want = 0;
        if (a.giftQty === want) return { cart: cart };

        return post('cart/update.js', { updates: giftUpdates(want) }).then(function (updated) {
          var line = (updated.items || []).filter(isGift)[0];
          if (!line || line.final_line_price === 0) return { cart: updated, changed: true };
          // Shopify didn't make it free (another discount won) — take it back out.
          failedAt = a.spend;
          return post('cart/update.js', { updates: giftUpdates(0) }).then(function (c) {
            return { cart: c, changed: true };
          });
        });
      })
      .then(function (res) {
        if (!res.cart || !res.cart.items) return;
        if (res.changed) refreshCartUI(res.cart);
        renderWidget(res.cart);
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (queued) { queued = false; schedule(); }
      });
  }

  // ---- Floating gift button + panel (snippets/ic-free-gift.liquid) ----

  function money(pence) {
    var v = pence / 100;
    return '£' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }

  function renderWidget(cart) {
    var w = document.querySelector('[data-ic-gift]');
    if (!w) return;
    var a = analyse(cart);
    var unlocked = a.giftQty > 0 && a.giftTotal === 0;
    var left = Math.max(cfg.threshold - a.spend, 0);
    var pct = Math.min(a.spend / cfg.threshold * 100, 100);
    var state = unlocked ? 'unlocked' : (a.otherDiscount && left === 0 ? 'blocked' : 'progress');

    w.setAttribute('data-state', state);
    w.querySelector('[data-ic-gift-bar]').style.width = (unlocked ? 100 : pct) + '%';
    w.querySelector('[data-ic-gift-left]').textContent = money(left);
    w.querySelector('[data-ic-gift-pill]').textContent = unlocked ? '✓' : (a.spend > 0 ? money(left) : '');
  }

  function initWidget() {
    var w = document.querySelector('[data-ic-gift]');
    if (!w) return;
    var btn = w.querySelector('[data-ic-gift-toggle]');
    function setOpen(open) {
      w.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    btn.addEventListener('click', function () { setOpen(!w.classList.contains('is-open')); });
    w.querySelector('[data-ic-gift-close]').addEventListener('click', function () { setOpen(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
    document.addEventListener('click', function (e) { if (!w.contains(e.target)) setOpen(false); });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 400);
  }

  // Watch every way the theme and apps change the cart.
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : input && input.url;
    var p = nativeFetch(input, init);
    if (isCartWrite(url)) p.then(schedule, schedule);
    return p;
  };

  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartWrite(url)) this.addEventListener('loadend', schedule);
    return nativeOpen.apply(this, arguments);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initWidget(); schedule(); });
  } else {
    initWidget(); schedule();
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(); });
})();
